import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { d: "M18.586 4H13V2h9v9h-2V5.414l-5.293 5.293-1.414-1.414L18.586 4zM5.414 20H11v2H2v-9h2v5.586l5.293-5.293 1.414 1.414L5.414 20z" }));
export default createSvgIcon(iconPath, "Expand");
//# sourceMappingURL=ExpandIcon.js.map